// extracted by mini-css-extract-plugin
export var arrowLg = "styles-module--arrowLg--007f4";
export var arrowMd = "styles-module--arrowMd--a49da";
export var button = "styles-module--button--77a4d";